// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3sfCP","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3wIxY","obliqueLine":"membershipbadge_obliqueLine__1deMo"};